import styled from "styled-components";

export const CloseBtn = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: ${props => props.theme.brand.canvas};
  cursor: pointer;
  outline: none;
  transition: ${props => props.theme.transition.main};

  svg {
    width: 18px;
    height: 18px;
    color: ${props => props.theme.brand.muted};
    stroke-width: 1;
  }

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.secondary};

    svg {
      color: ${props => props.theme.brand.chalk};
    }
  }

  @media (min-width: 768px) {
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;

    svg {
      width: 22px;
      height: 22px;
    }
  }
`;